import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {Status} from 'nutshell-graphql-types';

import {FlashBanner} from '../../../client_modules/shells/react/components/flash-banner/flash-banner';

import {useGetSessionUser} from '../../core/use-get-session-user';

type Props = {
    status: Status;
};

export function SnippetStatusBanner(props: Props) {
    const {user} = useGetSessionUser();

    if (
        (props.status !== Status.NEVER_CONFIGURED && props.status !== Status.NOT_WORKING) ||
        !user
    ) {
        return null;
    }

    return (
        <FlashBanner type='warning' hasBorder={true}>
            <div className='flex justify-sb full-width'>
                <Body color='warn'>
                    {getSnippetStatusText(props.status, user.permissions.canAccessSetup)}
                </Body>
                {user && user.permissions.canAccessSetup && (
                    <>
                        {/* @ts-expect-error */}
                        <Link as={RoutedLink} variant='primary' to='/setup/tracking-snippet'>
                            Embed tracking snippet
                        </Link>
                    </>
                )}
            </div>
        </FlashBanner>
    );
}

function getSnippetStatusText(status: Status, canAccessSetup: boolean) {
    switch (status) {
        case 'NEVER_CONFIGURED':
            return canAccessSetup
                ? "We don't detect a tracking snippet yet. Add the snippet to start capturing visitors"
                : "We don't detect a tracking snippet yet. Ask your administrator to embed the snippet to start capturing visitors";
        case 'NOT_WORKING':
            return canAccessSetup
                ? 'We haven’t detected visits in a few days. Please confirm you’ve embedded the correct snippet on your site'
                : 'We haven’t detected visits in a few days. Please ask your administrator to verify the tracking snippet is correctly installed';
    }
}
